import { render, staticRenderFns } from "./working-policy-detail-info.vue?vue&type=template&id=5726e5fc&scoped=true&"
import script from "./working-policy-detail-info.vue?vue&type=script&lang=js&"
export * from "./working-policy-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./working-policy-detail-info.vue?vue&type=style&index=0&id=5726e5fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5726e5fc",
  null
  
)

export default component.exports